import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { CultureInfo } from "../../Models/Culture/CultureInfo";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

@ModuleName("VoucherPayment")
export class VoucherPayment implements AxInit {
    constructor(private _AxLimestone = new AxLimeStone(),
        private _i18nHelper = new I18nHelper()) { }

    private PriceHelper: PriceHelper;

    AxInit(init: VoucherPaymentInitData): void {
        this.PriceHelper = new PriceHelper(init.CultureInfo, false);

        $('#kt_portlet__resort_charge').on('click', '.payment__voucherPayment-redeem', x => {
            $('.payment__voucherPayment-info').addClass('d-none');
            let voucherData = $('#payment__voucherPayment-form').serialize();
            this._AxLimestone.LockButton(x.currentTarget);

            AxessViewer.loadPartialView('/VoucherPayment/CheckVoucher', voucherData, (resp: BalanceResult) => {
                $('#payment__voucherPayment-form .ax-form-group-assistance').html('');
                $('.payment__voucherPayment-message').html('');

                if (resp.IsRedeemable) {
                    $('.payment__voucherPayment-info').removeClass('d-none');
                    $('.payment__voucherPayment-value').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(resp.UsedAmount) * -1));
                    $('.payment__voucherPayment-available').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(resp.BalanceInCents)));

                    if (!resp.PartlyRedeemable) {
                        $('.payment__voucherPayment-addition')
                            .html(this._i18nHelper.GetTranslation(Translations.VoucherNotPartlyRedeemable));
                    }
                } else {
                    $('.payment__voucherPayment-value').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(0)));
                    $('.payment__voucherPayment-available').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(0)));
                }

                $('.payment__bank-value').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(resp.RestAmount)));
                if (resp.Message !== '') {
                    $('.payment__voucherPayment-info').removeClass('d-none');

                    $('#payment__voucherPayment-form .ax-form-group-assistance').html(resp.Message);
                    $('#payment__voucherPayment-form .ax-form-group-assistance').toggleClass('success', resp.IsRedeemable);

                    $('.payment__voucherPayment-message').html(resp.Message);
                    $('.payment__voucherPayment-message').toggleClass('ax-color-red-400', !resp.IsRedeemable);
                }
                this._AxLimestone.UnlockButton(x.currentTarget);
            }, {});
        });
    }
}

interface VoucherPaymentInitData {
    CultureInfo: CultureInfo
}

interface BalanceResult {
    Code: string;
    BalanceInCents: number;
    TotalAmountInCents: number;
    Message: string;
    IsRedeemable: boolean;
    RestAmount: number;
    PartlyRedeemable: boolean;
    UsedAmount: number;
}